import React, { useContext, useEffect, useState } from 'react';
import {
	Row,
	Col,
} from 'reactstrap';
import {
	FirstPageOutlined,
	LastPageOutlined,
	ChevronRightOutlined,
	ChevronLeftOutlined,
	AddCircleOutline
} from '@mui/icons-material';
import Pagination from 'react-js-pagination';

import { color } from '~/assets/styles/colors';
import { LoaderLista } from '~/components/Loaders';
import { FiltroPedidos } from '~/components/Filtros/FiltroPedidos';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { Text } from '../../../components/Text';
import { LancamentosData } from '../../../components/ExtratoData/Lancamentos';
import { LancamentosDataSemNotas } from '../../../components/ExtratoDataSemNotas/Lancamentos';
// import { ExtratoCreditoRevenda } from '../../../components/ExtratoData/ExtratoCreditoRevenda';
import { ModalSolicitarPedido } from '../../../components/Modal/SolicitarPedido';

import { PedidoContext } from '../../../context/PedidoContext';
import { ButtonStyle } from './styles';
import { Montante } from '../../../components/Montante';

export default function Lancamentos(props) {
	const { user, isMobile } = props;

	const [meusLancamentos, setMeusLancamentos] = useState([]);
	const [totalItems, setTotalItems] = useState(0);
	const projetosNotaFiscal = ['intelbras'];

	const {
		loadingPedido,
		setLoadingPedido,
		getResumo,
		setPedidos,
		getPedidos,
		montanteLancamento,
		destinatarios,
		loadingLancamento,
		setLoadingLancamento
	} = useContext(PedidoContext);

	const [pagina, setPagina] = useState(1);
	const [toggle, setToggle] = useState(false);
	const [toggleVisualizar, setToggleVisualizar] = useState(false);
	const [toggleVisualizarSemNota, setToggleVisualizarSemNota] = useState(false);
	const [atualizaNF, setAtualizaNF] = useState('');
	const [filtroData, setFiltroData] = useState('');
	const [filtroStatus, setFiltroStatus] = useState('');
	const [filtroPesquisa, setFiltroPesquisa] = useState('');

	const [expanded, setExpanded] = useState(false);

	const handleChange = (panel) => (event, isExpanded) => {
		setExpanded(isExpanded ? panel : false);
	};

	function handlerPagination(page) {
		setPagina(page);
		setLoadingPedido(false);
		getPedidos(10, page, 'enviados', filtroData, filtroStatus, filtroPesquisa).then(res => {
			res?.data?.total && setTotalItems(res.data.total);
			res?.data?.pedidos && setMeusLancamentos(res.data.pedidos);
			setLoadingPedido(true);
		});
	}

	useEffect(() => {
		getResumo( 10, 1, '', '')
		getPedidos(10, pagina, 'enviados', filtroData, filtroStatus, filtroPesquisa).then(res => {
			res?.data?.total && setTotalItems(res.data.total);
			res?.data?.pedidos && setMeusLancamentos(res.data.pedidos);
		});
	}, []);

	useEffect(() => {
		if (filtroData || filtroStatus || filtroPesquisa === '' || (filtroPesquisa && filtroPesquisa.length > 0)) {
			getPedidos(10, pagina, 'enviados', filtroData, filtroStatus, filtroPesquisa).then(res => {
				res?.data?.total && setTotalItems(res.data.total);
				res?.data?.pedidos && setMeusLancamentos(res.data.pedidos);
				if (atualizaNF === 'mudou') {
					setAtualizaNF('')
				}
			});
		}
	}, [filtroData, filtroStatus, filtroPesquisa, atualizaNF]);

	// const RowCred = (
	// 	<Col sm="12" md="8" lg="9">
	// 		<>
	// 			{(user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor') && (<Text style={{ margin: '0 0 10px 0' }}>CRÉDITO POR REVENDA</Text>)}
	// 			{(user.dados.cargo.toLowerCase() === 'industria') && <Text style={{ margin: '0 0 10px 0' }}>CRÉDITO DISTRIBUIDOR</Text>}

	// 			<ExtratoCreditoRevenda
	// 				isMobile={isMobile}
	// 				totalItemsResumo={totalItemsResumo}
	// 				getResumo={getResumo}
	// 				setDataResumo={setDataResumo}
	// 				resumos={dataResumo && dataResumo.dados ? dataResumo.dados : []}
	// 				user={user}
	// 				loadingResumo={loadingResumo}
	// 				setLoadingResumo={setLoadingResumo}
	// 			/>
	// 		</>
	// 	</Col>
	// )

	const RowLancamento = (
		<Col sm="12" md="8" lg="9">
			<>
				<>
					<Text>LANÇAMENTOS</Text>
					<FiltroPedidos
						user={user}
						isMobile={isMobile}
						aba="lancamentos"
						filtroPesquisa={filtroPesquisa}
						filtroData={filtroData}
						setFiltroData={setFiltroData}
						setFiltroStatus={setFiltroStatus}
						filtroStatus={filtroStatus}
						setPagina={setPagina}
						setFiltroPesquisa={setFiltroPesquisa}
						loadingLancamento={loadingLancamento}
						setLoadingLancamento={setLoadingLancamento}
					/>
					<LoaderLista loading={!loadingPedido} lista={meusLancamentos}>
						{projetosNotaFiscal.includes(user.dados.tipo_projeto.toLowerCase()) ?
							<LancamentosData
								toggleVisualizar={toggleVisualizar}
								setAtualizaNF={setAtualizaNF}
								setToggleVisualizar={setToggleVisualizar}
								lancamentos={meusLancamentos}
								user={user}
								loadingPedido={loadingPedido}
								setPagina={setPagina}
							/>
							:
							<LancamentosDataSemNotas
								toggleVisualizar={toggleVisualizarSemNota}
								setToggleVisualizar={setToggleVisualizarSemNota}
								lancamentos={meusLancamentos}
								user={user}
								loadingPedido={loadingPedido}
								setPagina={setPagina}
							/>
						}
						<div className={`d-flex ${isMobile ? 'justify-content-center' : 'justify-content-end'}`}>
							<Pagination
								activePage={pagina}
								totalItemsCount={totalItems}
								onChange={(page) => handlerPagination(page)}
								prevPageText={<ChevronLeftOutlined />}
								nextPageText={<ChevronRightOutlined />}
								firstPageText={<FirstPageOutlined />}
								lastPageText={<LastPageOutlined />}
							/>
						</div>
					</LoaderLista>
				</>
			</>
		</Col>
	)
	return (
		<>
			{isMobile ?
				<Accordion style={{ margin: '20px 0 20px 0', backgroundColor: color.greenLight }} expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel1bh-content"
						id="panel1bh-header"
						style={{ backgroundColor: color.primary }}
					>
						<Typography sx={{ width: '100%', flexShrink: 0 }}>
							{user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' && <Text>Cred. Revenda</Text>}
							{user.dados.cargo.toLowerCase() === 'industria' && <Text>Cred. Distribuidor</Text>}
						</Typography>
					</AccordionSummary>
					<Row style={{ padding: '10px' }}>{RowLancamento}</Row>
				</Accordion>
				:
				<div>
					<Row style={{ padding: '10px' }}>
						{RowLancamento}
						<Col sm="12" md="4" lg="3">
							{user.dados.permissoes.view_credito_revenda ?
								<Montante data={{montante: montanteLancamento}} /> : <></>}
							<div className={`d-flex ${isMobile ? 'justify-content-center' : 'justify-content-end'}`}>
								<ButtonStyle
									className="novoPedido"
									type="button"
									onClick={() => setToggle(true)}>
									<AddCircleOutline className="mr-2" />
									NOVO LANÇAMENTO
								</ButtonStyle>
							</div>
						</Col>
					</Row>
				</div>
			}

			{toggle &&
				<ModalSolicitarPedido
					destinatarios={destinatarios}
					setMeusLancamentos={setMeusLancamentos}
					setPedidos={setPedidos}
					setAtualizaNF={setAtualizaNF}
					toggle={toggle}
					setToggle={setToggle}
				/>}
		</>
	);
}
